import React from 'react';
import { useGame } from '../../context/GameContext';
import './WordCreation.css';

const WordCreation = () => {
  const { 
    gameState, 
    currentEra, 
    assignedWords, 
    wordInputs, 
    handleWordInputChange, 
    createWord, 
    handleKeyPress,
    game,
    socket
  } = useGame();

  // Only show this component in Era 0 and when game state is word_creation
  if (gameState !== 'word_creation' || currentEra !== 0) {
    return null;
  }

  return (
    <div className="word-creation-section">
      <h3>Create New Words</h3>
      {assignedWords.length > 0 ? (
        <>
          <p className="instruction-text">
            Create new spellings for these words in the Gibberers language.
          </p>
          <div className="word-cards-grid">
            {assignedWords.map(word => (
              <div key={word} className="word-card">
                <div className="original-word-display">{word}</div>
                <input
                  type="text"
                  value={wordInputs[word] || ''}
                  onChange={(e) => handleWordInputChange(word, e.target.value)}
                  onKeyPress={(e) => handleKeyPress(e, word)}
                  placeholder="Enter your new word"
                  className="word-card-input"
                />
                <button 
                  onClick={() => createWord(word, wordInputs[word]?.trim())}
                  disabled={!wordInputs[word]?.trim()}
                  className="word-card-button"
                >
                  Add to Dictionary
                </button>
              </div>
            ))}
          </div>
          
          {/* Show other players who are still creating words */}
          {game?.players && game.players.filter(p => 
            p.id !== socket?.id && 
            p.assignedWords && 
            p.assignedWords.length > 0
          ).length > 0 && (
            <div className="players-creating-words">
              <p className="waiting-text">
                Other players still creating words:
              </p>
              <ul className="creating-players-list">
                {game.players
                  .filter(p => p.id !== socket?.id && p.assignedWords && p.assignedWords.length > 0)
                  .map(player => (
                    <li key={player.id} className="creating-player">
                      {typeof player.name === 'string' ? player.name : ''} 
                      {player.assignedWords && (
                        <span className="words-remaining">
                          ({player.assignedWords.length} word{player.assignedWords.length !== 1 ? 's' : ''} remaining)
                        </span>
                      )}
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </>
      ) : (
        <div className="all-words-complete">
          <p>You have defined all your words!</p>
          <div className="players-creating-words">
            <p className="waiting-text">
              Waiting for other players to finish:
            </p>
            <ul className="creating-players-list">
              {game?.players
                .filter(p => p.assignedWords && p.assignedWords.length > 0)
                .map(player => (
                  <li key={player.id} className="creating-player">
                    {typeof player.name === 'string' ? player.name : ''} 
                    {player.assignedWords && (
                      <span className="words-remaining">
                        ({player.assignedWords.length} word{player.assignedWords.length !== 1 ? 's' : ''} remaining)
                      </span>
                    )}
                  </li>
                ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default WordCreation; 